import clsx from 'clsx';
import { useFormik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import { IoMdSearch } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import DrawerSkeleton from '../../..';
import { PlusIcon } from '../../../../Assets/icons';
import DecideServiceList from '../../../../Components/General/DecideServiceList';
import OpdFeeSection from '../../../../Components/General/OpdFeeSection';
import Button from '../../../../Components/UI/Button';
import { Input } from '../../../../Components/UI/Input';
import useClinic from '../../../../Features/useClinic';
import useDoctor from '../../../../Features/useDoctor';
import { transformServices } from '../../../../Helpers';
import AlertModal from '../../../../Modals/AlertModal';
import { serviceSchema } from '../../../../Schema';
import { setSelectedService } from '../../../../Store/serviceSlice';
import DrawerHeader from '../../../DrawerHeader';
import classes from './CreateAndViewServicesDrawer.module.css';
import useProfile from '../../../../Features/useProfile';
const initialValues = {
  id: 0,
  serviceFees: '',
  serviceName: ''
};

const fetchApiInParallel = async (...params) => {
  const apiCalls = [...params];
  try {
    await Promise.allSettled(apiCalls);
  } catch (error) {
    toast.error(new Error(error)?.message);
  }
};

const CreateAndViewServicesDrawer = ({
  show,
  setShow,
  setShow2,
  resetOfPrevDrawer,
  data,
  prev = true
}) => {
  const allServices = useSelector((state) => state?.serviceReducer?.services);

  const selectedServices = useSelector((state) => state?.serviceReducer?.selectedServices);
  const { editPatientQueuFees, editClinicFee, loading: clinicLoading } = useClinic();
  const dispatch = useDispatch();
  const [service, setService] = useState([]);
  const [search, setSearch] = useState('');
  const [showAreYouSureModal, setShowAreYouSureModal] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [disableServiceName, setDisableServiceName] = useState(false);
  const [formattedServiceFee, setFormattedServiceFee] = useState('');

  const { getAllServicesListing, loading, deleteServiceSubmit, addOrEditServiceSubmit } =
    useDoctor();
  const { getDoctorFee } = useProfile();
  const { getPatientQueueChecked, getAllPatientsQueue } = useClinic();
  const formik = useFormik({
    initialValues,
    validationSchema: serviceSchema,
    onSubmit: (values, { resetForm }) => {
      const afterSuccess = () => {
        getAllServicesListing();
        resetForm();
        setFormattedServiceFee('');
        setDisableServiceName(null);
      };
      addOrEditServiceSubmit(values, afterSuccess);
    }
  });
  const {
    touched,
    errors,
    values,
    handleSubmit,
    setValues,
    resetForm,
    setFieldValue,
    setFieldTouched,
    setTouched
  } = formik;

  const handleChangeWithTouch = (field, value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };

  const formRef = useRef(null);
  const handleScroll = () => {
    setShowCreate((currentState) => {
      if (!currentState) {
        setTimeout(() => {
          if (formRef.current) {
            formRef.current.scrollIntoView({ behavior: 'smooth' });
            // Adjust the parent element's scroll position
          }
        }, 100); // Adding a slight delay
      }
      return !currentState;
    });
  };

  const isButtonDisabled = Object.keys(errors).length === 0 && Object.keys(touched).length > 0;

  // on service Edit
  const onEditService = (service) => {
    setDisableServiceName(true);
    setTouched({
      name: true, // Mark the name field as touched
      fee: true // Mark the fee field as touched
    });
    setValues({
      ...service
    });
    setShowCreate((currentState) => {
      setTimeout(() => {
        if (formRef.current) {
          formRef.current.scrollIntoView({ behavior: 'smooth' });
          // Adjust the parent element's scroll position
        }
      }, 100); // Adding a slight delay
      return true;
    });
  };
  const onCancel = () => {
    setShowAreYouSureModal(false);
    resetForm();
  };
  //delete Item from the list
  const deleteService = (id) => {
    deleteServiceSubmit({ serviceId: id }, () => {
      setDisableServiceName(null);
      onCancel();
    });
  };
  const onClose = () => setValues(initialValues);
  const resetAllState = () => {
    resetForm();
    setShowCreate(false);
    setShow();
    dispatch(setSelectedService([]));
  };
  const handleFormSubmit = () => {
    const servicesTaken = selectedServices?.flatMap((item) =>
      Array(item?.quantity).fill(item?.serviceId)
    );
    editPatientQueuFees(
      {
        opdId: data?.opdId,
        isOpd: servicesTaken.includes(null),
        appliedFees: [...servicesTaken].filter((data) => data != null)
      },
      () => {
        fetchApiInParallel(getAllPatientsQueue(), getPatientQueueChecked());
        setShow();
        // resetAllState();
      }
    );
  };

  let filterService = allServices;
  useEffect(() => {
    if (data?.patientOPDDetail?.length > 0 && show) {
      dispatch(setSelectedService(transformServices([...data?.patientOPDDetail])));
    }
  }, [data, show]);

  useEffect(() => {
    if (show) getAllServicesListing();
  }, [show]);
  if (search)
    filterService = allServices?.filter(
      (data) =>
        String(data?.serviceFees)?.toLowerCase()?.includes(search?.toLowerCase()) ||
        data?.serviceName?.toLowerCase()?.includes(search.toLowerCase())
    );
  const handleServiceFeeChange = (value) => {
    const rawValue = value.replace(/,/g, '');
    const formattedValue = Number(rawValue).toLocaleString();
    handleChangeWithTouch('serviceFees', rawValue);
    setFormattedServiceFee(formattedValue);
  };
  return (
    <DrawerSkeleton
      show={show}
      setShow={() => {
        onClose();
        typeof resetOfPrevDrawer === 'function' && resetOfPrevDrawer();
        resetForm();
        setShow();
        setShowCreate(false);
        //empty all Services
        // dispatch(setSelectedService([]));
      }}>
      <div className={clsx(classes.wrapper)}>
        <DrawerHeader
          prev={prev}
          setShow2={() => {
            if (typeof setShow2 === 'function') {
              setShow2();
              setShowCreate(false);
            }
          }}
          setShow={() => {
            onClose();
            setShow();
            setShowCreate(false);
          }}
          onClose={() => {
            dispatch(setSelectedService([]));
          }}
          title={'Service(s)'}
        />
        {/* Draw all services and perform operations on it */}
        <div className={clsx(classes.content, 'scrollbar1')}>
          <div className={classes.searchContainer}>
            <Input
              leftIcon={<IoMdSearch size={22} color="var(--primary-color)" />}
              id={'search-services001'}
              value={search}
              setter={setSearch}
              placeholder="Search Services"
              type="text"
              inputStyle={{ padding: '10px 16px', paddingLeft: '0px' }}
              customStyle={{ background: 'var( --secondary-color)', borderRadius: '8px' }}
            />
          </div>
          <OpdFeeSection
            loading={clinicLoading}
            showButton={false}
            show={show}
            allServices={allServices}
            onSubmit={(params) => {
              editClinicFee(params, () => {
                getDoctorFee();
              });
            }}
          />

          <DecideServiceList
            value={filterService} //this state holds all services that comes from api
            setter={setService}
            onEditService={onEditService}
            onDeleteService={() => setShowAreYouSureModal(true)}
          />
          {/* action  */}
          <div className={classes.actionWrapper}>
            {selectedServices?.length > 1 && (
              <Button
                variants="secondary"
                label={'Delete Service(s)'}
                className={classes.deleteBtn}
              />
            )}
            <Button
              variants="add"
              className={clsx(classes.btn, {
                [classes.cancelForm]: showCreate
              })}
              onClick={() => {
                resetForm();
                setDisableServiceName(null);
                handleScroll(); // Scroll only if showing the form
                setFormattedServiceFee('');
              }}
              label={showCreate ? 'Cancel' : 'Create New'}
              leftIcon={<PlusIcon color="var(--primary-color)" size={15} />}
            />
          </div>
          {/* Form wrapper */}
          <div
            className={clsx(classes.formContainer, {
              [classes.closeContainer]: !showCreate
            })}>
            <form className={classes.createNewComponent} onSubmit={handleSubmit}>
              <h1 className={classes.heading}>Add Service(s)</h1>

              <Input
                disabled={disableServiceName}
                id={'Service Name'}
                label={'Service Name'}
                placeholder="Enter Service(s)"
                setter={(value) => handleChangeWithTouch('serviceName', value)}
                value={values?.serviceName}
                errorText={touched?.serviceName && errors?.serviceName}
              />
              <Input
                id={'Service Fee'}
                regexType="format"
                // type="number"
                value={formattedServiceFee || values?.serviceFees}
                label={'Service Fee'}
                placeholder="Enter Fee"
                setter={handleServiceFeeChange}
                errorText={touched?.serviceFees && errors?.serviceFees}
              />

              <div className={classes.ctaWrapper}>
                <Button
                  variants="secondary"
                  label={'Cancel'}
                  className={classes.deleteBtn}
                  onClick={() => {
                    if (values?.serviceName || values?.serviceFees) {
                      resetForm();
                    } else {
                      setShowCreate(false);
                    }
                    setDisableServiceName(null);
                  }}
                />
                <Button
                  label={'Save'}
                  type="submit"
                  disabled={!isButtonDisabled || loading}
                  className={classes.save}
                />
              </div>
              <div ref={formRef} />
            </form>
          </div>
        </div>
        <div className={classes.bottomActionWrapper}>
          <Button
            variants="secondary"
            label={'Close'}
            onClick={() => {
              typeof resetOfPrevDrawer === 'function' && resetOfPrevDrawer();
              resetForm();
              setShowCreate(false);
              setShow();
              //empty all Services
              dispatch(setSelectedService([]));
            }}
          />
          {data && (
            <Button
              disabled={clinicLoading}
              variants="primary"
              label={'Add'}
              onClick={() => {
                typeof resetOfPrevDrawer === 'function' && resetOfPrevDrawer();
                if (data) {
                  handleFormSubmit();
                } else {
                  resetAllState();
                }
              }}
            />
          )}
        </div>
      </div>
      {showAreYouSureModal && (
        <AlertModal
          loading={loading}
          title={'Delete Service'}
          content={
            <span>
              Are you sure you want to delete the service{' '}
              <span className={classes.contentName}>{service?.serviceName} </span>
            </span>
          }
          onConfirm={() => deleteService(service?.serviceId)}
          show={showAreYouSureModal}
          setShow={setShowAreYouSureModal}
        />
      )}
    </DrawerSkeleton>
  );
};

export default CreateAndViewServicesDrawer;
